<div class="page" id="page_modalities">
    <div class="container">

        <h2 class="section-title">MODALIDADES</h2>
        <p></p>

        <div class="head">
            <ul>
                <li>
                    <a class="jiu" (click)="navigate('jiu')">
                        <fa-icon [icon]="faIcon" />
                        <p>JIU JITSU</p>
                        <span>JJ</span>
                    </a>
                </li>
                <li>
                    <a class="funcional" (click)="navigate('funcional')">
                        <fa-icon [icon]="faIcon2" />
                        <p>FUNCIONAL FIGHT</p>
                        <span>FF</span>
                    </a>
                </li>

            </ul>

            <!-- <div class="page-footer">
                <h4>AGENDE UMA AULA EXPERIMENTAL</h4>
                
                <a class="btn primary-line" 
                    target="_blank"  
                    href="https://api.whatsapp.com/send?phone=+5511976626886&text=Olá, gostaria de obter informações sobre a New Fit Performance Club"
                    (click)="navigate('joinus')">
                    <span>AGENDAMENTOS </span>
                    <fa-icon [icon]="faWhatsapp" />
                </a>
            </div> -->

        </div>

        <div class="section-divider"></div>
        
        <div class="window">

            <div class="tabs jiu">
                <img class="bgimg" src="assets/tiny/jiu.jpeg" />
                <img src="assets/mock/mods-002.jpeg" class="icon-img" style="opacity: 0; height: 160px;" />
                <h3>JIU JITSU</h3>
                <p>
                    <!-- Técnica, estratégia e disciplina. <br/> 
                    Do iniciante ao avançado, para <br/>
                    todas as idades -->
                    
                    Muito mais do que uma luta.  <br/>
                    Desenvolva técnica,  <br/>
                    condicionamento físico,  <br/> 
                    autoconfiança e disciplina em um  <br/>
                    ambiente acolhedor, com aulas  <br/>
                    para todos os níveis.
                </p>
            </div>
            <div class="tabs funcional">
                <img class="bgimg" src="assets/tiny/functional01.jpeg" />
                
                <img src="assets/mock/mods-003.jpeg" class="icon-img" style="opacity: 0; height: 180px;" />
                <h3>FUNCIONAL FIGHT FEMININO</h3>
                <p style="padding-bottom: 180px;">
                    Treinos dinâmicos que combinam, <br/> 
                    condicionamento físico, força, <br/>
                    resistência e técnicas de luta
                </p>
            </div>
        </div>

        <div class="section-divider"></div>

        <div class="page-footer">
            <h4>AGENDE UMA AULA EXPERIMENTAL</h4>
            
            <a class="btn primary-line" 
                target="_blank"  
                href="https://api.whatsapp.com/send?phone=+5511976626886&text=Olá, gostaria de obter informações sobre a New Fit Performance Club"
                (click)="navigate('regclick')">
                <span>AGENDAMENTOS </span>
                <fa-icon [icon]="faWhatsapp" />
            </a>
        </div> 

        <div class="section-divider"></div>

    </div>
</div>